import LockerSignupLayout from './LockerSignupLayout';
import {LeagueLockerSignup} from '../types';
import { addLeagueLockerSignup, checkEmailExists } from '../services/firebase';
import React, { useEffect, useState } from 'react';
import { useAuth } from "../contexts/AuthContext";


const LockerSignupPage: React.FC = () => {
  const { user } = useAuth();
  const klaviyoListId = process.env.REACT_APP_KLAVIYO_LIST_ID;
  const [formData, setFormData] = useState({
    email: '',
    leagueDescription: '',
    subscribe: true
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<{type: 'success' | 'error', text: string} | null>(null);

  // Email validation regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const validateForm = (): string[] => {
    const errors: string[] = [];
    
    // Email validation
    if (!formData.email.trim()) {
      errors.push('Email is required');
    } else if (!emailRegex.test(formData.email.trim())) {
      errors.push('Please enter a valid email address');
    }
    
    // League description validation
    if (!formData.leagueDescription.trim()) {
      errors.push('League description is required');
    }
    
    return errors;
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage(null);
    
    const validationErrors = validateForm();
    if (validationErrors.length > 0) {
      setMessage({
        type: 'error',
        text: validationErrors.join(', ')
      });
      return;
    }

    setLoading(true);
    
    try {
      // Check if email already exists
      const emailExists = await checkEmailExists(formData.email);
      if (emailExists) {
        setMessage({
          type: 'error',
          text: 'Your request is already there. We have your email and will contact you if your league is selected for the beta.'
        });
        setLoading(false);
        return;
      }

      await addLeagueLockerSignup(formData.email, formData.leagueDescription);
      setMessage({
        type: 'success',
        text: 'Thank you! Your signup has been submitted successfully. We will email you if your league is selected for the beta.'
      });

      if(formData.subscribe) {
        // Add to newsletter subscription logic here
        console.log(`Subscribing ${formData.email} to the newsletter.`);
        // You can call your newsletter subscription service here
        if(window.location.hostname === 'localhost') {
          console.log('Skipping newsletter subscription in development mode.');
          setLoading(false);
        } else {
          const response = await fetch("/.netlify/functions/subscribe", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              email: formData.email,
              listId: klaviyoListId,
            }),
          });

          // Handle the response
          const data = await response.json();
          console.log(data);
        }
        
      }

      // Reset form
      setFormData({
        email: '',
        leagueDescription: '',
        subscribe: false
      });
    } catch (error) {
      console.error('Signup error:', error);
      setMessage({
        type: 'error',
        text: 'Something went wrong. Please try again later.'
      });
    } finally {
      setLoading(false);
    }
  };

  /* useEffect(() => {
    if (user && user.email) {
      setFormData(prev => ({ ...prev, email: user.email || '' }));
    }
  }, [user]); */

  return (
    <LockerSignupLayout>
      {message && (
        <div className={`message ${message.type === 'success' ? 'success' : 'error'}`}>
          {message.text}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div className="formGroup">Enter your email address and tell us a bit about your league to get placed on the beta list! We are only open for a select number of leagues. We will email you if your league is selected!</div>
        <div className="formGroup">
          <input
            type="email"
            placeholder="Email address"
            required
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            autoFocus
          />
        </div>
        <div className="formGroup">
          <textarea 
            placeholder="Provide some details about your league" 
            name="leagueDescription"
            value={formData.leagueDescription}
            onChange={handleInputChange}
            required
          ></textarea>
        </div>
        <div className="formGroup">
            <label className="checkboxLabel">
                <input 
                  type="checkbox" 
                  name="subscribe" 
                  checked={formData.subscribe}
                  onChange={handleInputChange}
                />
                Subscribe to Newsletter
            </label>
        </div>

        <button type="submit" className="btnStyle" disabled={loading}>
          {loading ? 'Submitting...' : 'Submit'}
        </button>
      </form>
    </LockerSignupLayout>
  );
};

export default LockerSignupPage;
